import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import MomSysInspectionRsltRegisterDialog from "../dialogTypes/MomSysInspectionRsltRegisterDialog";

function MomSysInspectionRsltRegisterButton(props) {
    const { id, refresh, schema, inspectionSelect, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const { t } = useTranslation();

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);

        if (refresh) {
            refresh.refresh();
        }
    };

    const onRegisterSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <React.Fragment>
            <ActionButtonLayout id={`${id}-create-button`} onClick={onOpen} {...others}>
                {t("buttonName.create")}
            </ActionButtonLayout>
            <MomSysInspectionRsltRegisterDialog
                id={id + "-register-dialog"}
                schema={schema}
                inspectionSelect={inspectionSelect}
                open={open}
                onClose={onClose}
                onSuccess={onRegisterSuccess}
            />
        </React.Fragment>
    );
}

export default MomSysInspectionRsltRegisterButton;
